import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'pxl-invite-user-dialog',
  standalone: false,
  template: `
    <h1 mat-dialog-title>Invite User</h1>
    <div mat-dialog-content>
      <form [formGroup]="inviteForm">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" type="email" placeholder="Enter email" />
          <mat-error *ngIf="inviteForm.get('email')?.invalid && inviteForm.get('email')?.touched">
            Please enter a valid email.
          </mat-error>
        </mat-form-field>
      </form>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-flat-button color="accent" (click)="onSubmit()" [disabled]="inviteForm.invalid">
        Send Invite
      </button>
    </div>
  `,
  styles: [
    `
      .full-width {
        width: 100%;
      }
    `
  ]
})
export class InviteUserDialogComponent {
  inviteForm: FormGroup;

  constructor(private dialogRef: MatDialogRef<InviteUserDialogComponent>, private fb: FormBuilder) {
    this.inviteForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onSubmit(): void {
    if (this.inviteForm.valid) {
      const email = this.inviteForm.value.email;
      this.dialogRef.close(email);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
